import React, { Fragment } from "react";
import Icon from "../Icon";
import PropTypes from "prop-types";
import { fundStatusColor, fundStatusLabel } from "../../helpers/fund";

const Disease = ({ disease, displayStatus }) => {
  function renderTitle() {
    if (disease.permalink) {
      return (
        <a className="Glossary-term" href={disease.permalink}>
          {disease.Fund_Name}
        </a>
      );
    } else {
      return (
        <p className="Glossary-term -static">
          {disease.Fund_Name}
        </p>
      );
    }
  }

  if (!disease.Fund_Name) {
    return null;
  }

  return (
    <Fragment>
      <div className="Glossary-termWrapper">
        {renderTitle()}
        {displayStatus && (
          <div>
            <p className={`Glossary-term-label f-label-small Glossary-term-label--${fundStatusColor(disease)}`}>
              {fundStatusLabel(disease)}
            </p>
          </div>
        )}
      </div>
    </Fragment>
  );
};

Disease.protoTypes = {
  disease: PropTypes.object,
  displayStatus: PropTypes.bool,
};

export default Disease;
